export default __webpack_public_path__ + "static/media/6.9bf7e73f.jpg";